import {
    GET_ORG_PROPERITES_COLLECTION,
    GET_ORG_PROPERITES_COLLECTION_SUCCESS,
    GET_ORG_PROPERITES_COLLECTION_FAILURE,
    GET_PROPERTY_BY_ID,
    GET_PROPERTY_BY_ID_FAILURE,
    GET_PROPERTY_BY_ID_SUCCESS,
    SET_ACTIVE_USER_PROPERTY,
    SET_ACTIVE_USER_PROPERTY_SUCCESS,
    SET_ACTIVE_USER_PROPERTY_FAILURE,
    SET_ORGANIZATION_PROPERTY,
    IMPORT_ORG_PROPERITES,
    IMPORT_ORG_PROPERITES_SUCCESS,
    IMPORT_ORG_PROPERITES_FAILURE,
    RESET_IMPORT_ORG_PROPERITES
} from './types';

export const resetImportOrgProperties = () => {
    return {
        type: RESET_IMPORT_ORG_PROPERITES
    };
};

export const importOrgProperties = payload => {
    return {
        type: IMPORT_ORG_PROPERITES,
        payload: payload
    };
};

export const importOrgPropertiesFailure = error => {
    return {
        type: IMPORT_ORG_PROPERITES_FAILURE,
        payload: error
    };
};

export const importOrgPropertiesSuccess = data => {
    return {
        type: IMPORT_ORG_PROPERITES_SUCCESS,
        payload: data
    };
};

export const getOrgPropertiesCollection = org => {
    return {
        type: GET_ORG_PROPERITES_COLLECTION,
        payload: org
    };
};

export const getOrgPropertiesCollectionFailure = error => {
    return {
        type: GET_ORG_PROPERITES_COLLECTION_FAILURE,
        payload: error
    };
};

export const getOrgPropertiesCollectionSuccess = data => {
    return {
        type: GET_ORG_PROPERITES_COLLECTION_SUCCESS,
        payload: data
    };
};

export const setOrganizationProperty = data => {
    return {
        type: SET_ORGANIZATION_PROPERTY,
        payload: data
    };
};

export const getPropertyByIdCollection = propertyId => {
    return {
        type: GET_PROPERTY_BY_ID,
        propertyId: propertyId
    };
};

export const getPropertyByIdCollectionFailure = error => {
    return {
        type: GET_PROPERTY_BY_ID_FAILURE,
        payload: error
    };
};

export const getPropertyByIdCollectionSuccess = data => {
    return {
        type: GET_PROPERTY_BY_ID_SUCCESS,
        payload: data
    };
};

export const setActiveUserProperty = property => ({
    type: SET_ACTIVE_USER_PROPERTY,
    payload: property
});

export const setActiveUserPropertySuccess = propertyData => ({
    type: SET_ACTIVE_USER_PROPERTY_SUCCESS,
    payload: propertyData
});

export const setActiveUserPropertyFailure = error => ({
    type: SET_ACTIVE_USER_PROPERTY_FAILURE,
    payload: error
});
